import React, { useCallback, useMemo } from "react";
import { Input, Select } from "../../components/inputs";
import { ALL_PRODUCT_MODES_ARRAY } from "../../constants/Common";
import ReactDatePicker from "react-datepicker";
import { BsFillCalendar2Fill } from "react-icons/bs";
import { Button } from "../../components/buttons";
import ExamSelect from "../../components/AutoComplete/exam-select";
import { useRecoilValue } from "recoil";
import { allExams, authUser } from "../../providers";
import { instance } from "../../services/https/inceptors";
import { endpoints } from "../../constants/Endpoints";
import ReactSelect from "react-select";
import { showToast } from "../../utilities/toast";
import { convertEnumToString } from "../../utilities/helpers";
import ToggleButton from "../../components/toggle-button";

const CreateReferralCode = () => {
  const [title, setTitle] = React.useState("");
  const [code, setCode] = React.useState("");
  const [product, setProduct] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState(null);
  const [status, setStatus] = React.useState(true);

  const recoilAuth = useRecoilValue(authUser);
  const allExamsData = useRecoilValue(allExams);
  const [selectedExam, setSelectedExam] = React.useState(null);

  const [allExamDepartmentData, setAllDepartmentsData] = React.useState([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState(null);

  const clearData = useCallback(() => {
    setTitle("");
    setCode("");
    setProduct("");
    setDiscount("");
    setExpiryDate(null);
    setSelectedExam(null);
    setSelectedDepartment(null);
  }, []);

  const onSubmitReferralCode = useCallback(
    async (e) => {
      e.preventDefault();

      if (code?.length < 6) {
        showToast({
          type: "error",
          message: "Referral code should be at least 6 characters",
        });

        return;
      }

      const selectedExamId = selectedExam.value.split("/")[1];
      const { data } = await instance.post(endpoints.referralCode, {
        title,
        code,
        status,
        product,
        discount,
        exam: selectedExamId,
        expiryDate: expiryDate.setHours(23, 59, 59, 999),
        departments: selectedDepartment.map((depart) => depart?.value),
      });

      if (data) {
        clearData();
        showToast({
          type: "success",
          message: "Referral code created successfully",
        });
      }
    },
    [
      code,
      selectedExam?.value,
      title,
      status,
      product,
      discount,
      expiryDate,
      selectedDepartment,
      clearData,
    ]
  );

  const onSelectExam = useCallback(
    async (exam) => {
      setSelectedDepartment([]);
      // setSelectedExam(exam);
      if (exam) {
        const departs = await instance.get(
          endpoints.getAllowedDepartments +
            `?exam=${
              exam.split("/")[1]
            }&departmentPermissions=${recoilAuth.departmentPermissions.toString()}`
        );
        setAllDepartmentsData(departs.data);
      }
    },
    [recoilAuth.departmentPermissions]
  );

  const getDepartmentOptions = useCallback(() => {
    const options = [];
    allExamDepartmentData.forEach((depart) =>
      options.push({
        label: depart.title.toString(),
        value: depart?._id,
      })
    );
    return options;
  }, [allExamDepartmentData]);

  const shouldDisableSubmit = useMemo(() => {
    return (
      !title ||
      !code ||
      !product ||
      !discount ||
      !expiryDate ||
      !selectedExam ||
      !selectedDepartment
    );
  }, [
    discount,
    expiryDate,
    product,
    code,
    selectedDepartment,
    selectedExam,
    title,
  ]);

  return (
    <div className="container flex flex-col items-center justify-center ">
      <h2 className="space-heading">Create Referral Codes</h2>

      <form onSubmit={onSubmitReferralCode} className="w-1/2">
        <div className="flex justify-end">
          <ToggleButton
            className="mt-5 mb-2"
            label=""
            onChange={setStatus}
            value={status}
          />
        </div>
        <Input label="Title" value={title} onChange={setTitle} />
        <Input label="Referral Code" value={code} onChange={setCode} />

        <Select label="Mode" value={product} onChange={setProduct}>
          {ALL_PRODUCT_MODES_ARRAY.map((key) => (
            <option value={key}> {convertEnumToString(key)} </option>
          ))}
        </Select>

        <ExamSelect
          allExams={allExamsData}
          examSelectValue={selectedExam}
          selectExam={onSelectExam}
          setExamSelectValue={setSelectedExam}
          setAllDepartments={setAllDepartmentsData}
          setDepartSelectValue={setSelectedDepartment}
          loading={false}
        />

        <div className="mt-4">
          <h6 className="mb-1">Select Department</h6>
          <ReactSelect
            isMulti
            hideSelectedOptions
            filterOption={(option, searchText) => {
              return option.data.label
                .toLowerCase()
                .includes(searchText.toLowerCase());
            }}
            onChange={(e) => {
              setSelectedDepartment(e);
            }}
            placeholder="Select Exam"
            className="basic-single"
            classNamePrefix="select"
            value={selectedDepartment}
            isSearchable
            options={getDepartmentOptions()}
          />
        </div>

        <Input
          className="mt-4"
          label="Discount"
          placeholder="Enter Discount in %"
          type="number"
          value={discount}
          onChange={(value) => {
            if (value <= 99) {
              setDiscount(value);
            }
          }}
        />

        <div className="mt-4">
          <div className="mb-2">Expiry Date</div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div>
              <ReactDatePicker
                fixedHeight
                customInput={
                  <BsFillCalendar2Fill
                    cursor="pointer"
                    size={26}
                    color="green"
                  />
                }
                selected={expiryDate}
                minDate={Date.now()}
                onChange={(date) => setExpiryDate(date)}
              />
            </div>

            <div
              style={{
                width: "100%",
                cursor: "not-allowed",
                border: "1px solid gainsboro",
                padding: "5px 22px",
                borderRadius: "4px",
              }}
            >
              {expiryDate?.toString().length
                ? expiryDate?.toString()?.slice(0, 15)
                : "Date not selected"}
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-4">
          <Button
            type="submit"
            disabled={shouldDisableSubmit}
            className="w-25 mt-3"
          >
            Submits
          </Button>
        </div>
      </form>
    </div>
    // </div>
  );
};

export default CreateReferralCode;
